// extracted by mini-css-extract-plugin
export default {"container__component":"style_container__component__CRaGF","container__component_color":"style_container__component_color__VALVC"};